<template>
  <div class="contact-box">
    <div @click="showMsgDialog(true)" class="contact-box-item" @mouseover="isLeaveMsgHover=true" @mouseout="isLeaveMsgHover=false">
        <img :src="isLeaveMsgHover?leaveMsgHover:leaveMsg" style="width: 40px;height: 40px;transform: translateX(-6px);" />
        <span class="contact-box-item-label" style="transform: translateX(-6px);">给他留言</span>
    </div>
    <div @click="goToUserInfo" class="contact-box-item" @mouseover="isUserMsgHover=true" @mouseout="isUserMsgHover=false">
      <img :src="isUserMsgHover?userMsgHover:userMsg" style="width: 32px;height: 32px;margin-top: 7px;"/>
      <span class="contact-box-item-label">查看他的信息</span>
    </div>
    <div @click="showMsgDialog(false)" class="contact-box-item" style="position: relative;" @mouseover="isMsgBoxHover=true" @mouseout="isMsgBoxHover=false">
      <img :src="isMsgBoxHover?msgBoxHover:msgBox" style="width: 30px;height: 30px;margin-top: 7px;margin-right: 2px;"/>
      <span class="contact-box-item-label">留言盒</span>
      <div v-if="unReadMsgCount>0" style="position: absolute;width: 20px;height: 20px;border-radius: 20px;background-color: red;color: white;left: 40px;line-height: 20px;">{{unReadMsgCount}}</div>
    </div>
    <div class="contact-box-item" style="border: none;" @mouseover="isContactUsHover=true" @mouseout="isContactUsHover=false" @click="openContactUsDialog">
      <img :src="isContactUsHover?contactUsHover:contactUs" style="width: 32px;height: 32px;margin-top: 7px;"/>
      <div style="display: flex;flex-direction: column;margin-top: 7px;margin-left: 10px;"><span>联系代购</span><span>担保交易</span></div>
    </div>
    <el-dialog
      title="联系代购|担保"
      :visible.sync="contactUsDialog"
      width="30%"
      :append-to-body="true"
      :show-close="true"
      >
      <div class="contact-us-dialog">
        <h1>联系代购|担保交易</h1>
        <p style="color: red;">网站试运行阶段，所有交易均不收手续费</p>
        <p>1、本公司只负责代购，不生产、销售以及回收游戏道具与游戏货币，所购游戏道具或者游戏货币来自可信玩家手中，而非官网渠道购买，请用户知悉</p>
        <p>2、本公司也提供代购ms业务，担保商人信誉，不收手续费，目前商人售卖比例为1(元):31.5，最低交易金额10元，如果交易过程中出现小数，将舍弃小数部分，仅交易整数部分，部分区服不适用该比例，按照实际情况决定，此服务免费，不收钱任何手续费</p>
        <p>3、账号担保交易，交易额不足100元，按最低标准收3元佣金；交易额超过100元，按3%比例收取；交易额20万元以内，最高收取500元；交易额超过20万，按照1000元收取佣金，佣金由卖方支付</p>
        <p>4、账号出租，本公司仅负责保存相应的聊天记录与租号合约，并按照合约保存押金与支付租金，具体政策，请查看平台协议，本公司会按照合同中的月租金，按月收取月租金的1%作为佣金，不足一月按一个月算，当月收取佣金最高不超过300元，该佣金由卖方支付</p>
        <h2>微信扫码:</h2>
        <img :src="serviceQR" style="width: 292px;height: 300px;">
        <h2>或者微信添加联系人:13478460876</h2>
      </div>
    </el-dialog>
    <el-dialog
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="700px">
    <div class="msg-container">
      <div class="msg-container-left">
        <div v-for="item in senderInfoList" :key="item.userId" class="msg-container-left-item" @click="changeSelectedItem(item.userId)" :class="{active:selectedUserId===item.userId}">
          <img :src="(item.avatar==null||item.avatar=='')?defaultAvatar:item.avatar" style="width:40px;height: 40px;border-radius: 40px;margin-top: 10px;">
          <div style="font-size: 12px;width: 167px;height: 60px;display: flex;flex-direction: column;justify-content: center;">
            <span style="margin-left: 10px;display: flex;"><i style="display: inline-block;width: 83px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.userName}}</i>
            <i style="margin-left: 5px;display: inline-block;" v-if="item.latestMsg!=null">{{item.latestMsg.createTime.substring(0,10).split("-").join("/")}}</i></span>
            <span style="margin-left: 10px;display: block;margin-top: 5px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"  v-if="item.latestMsg!=null">{{item.userId===item.latestMsg.senderId?item.userName:"我"}}：{{item.latestMsg.content}}</span>
          </div>
          <div v-if="item.hasUnRead" style="position: absolute;width: 5px;height: 5px;border-radius: 5px;background-color: red;left: 5px;top: 5px;"></div>
        </div>
      </div>
      <div class="msg-container-right">
        <div class="msg-container-right-header">
            <div style="line-height: 38px;height: 38px;width: 430px;padding-left: 20px;font-size: 13px;">{{selectedUserName}}</div>
            <div class="el-icon-close" @click="dialogVisible=false"></div>
        </div>
        <div class="msg-container-right-top" ref="msgBody">
            <div v-if="hasMoreMsg" style="text-align: center;width: 100%;font-size: 12px;color: #000000;cursor: pointer;margin-top: 10px;" @click="getMoreMsg">点我加载更多</div>
            <div v-else style="text-align: center;width: 100%;font-size: 12px;color: #b9b9b9;" v-show="selectedMsgList.length>0">-----没有更多消息了-----</div>
            <div v-for="item in selectedMsgList" :key="item.id">
              <div style="text-align:left;display: flex;padding-left: 5px;padding-top: 5px;" v-if="selectedUserId===item.senderId">
                <img :src="(selectedUserAvatar==null||selectedUserAvatar=='')?defaultAvatar:selectedUserAvatar" style="width: 35px;height: 35px;border-radius: 35px;"/>
                <div style="width: 390px;line-height: 20px;margin-left: 5px;padding-top: 5px;">{{item.content}}</div>
              </div>
              <div style="text-align:right;display: flex;margin-left: 35px;" v-else>
                <div style="width: 390px;line-height: 20px;text-align: right;">
                  <div style="display: inline-block;text-align: left;padding-top: 5px;">
                    {{item.content}}
                  </div>
                </div>
                <img :src="($store.state.user.user.avatar==null||$store.state.user.user.avatar=='')?defaultAvatar:$store.state.user.user.avatar" style="width: 35px;height: 35px;border-radius: 35px;"/>
              </div>
              <div style="text-align: center;width: 100%;font-size: 12px;color: #b9b9b9;margin-top: 10px;margin-bottom: 10px;">-----{{item.createTime}}-----</div>
            </div>
        </div>
        <div class="msg-container-right-bottom">
          <textarea v-model="msgModel" placeholder="请输入留言" ref="msgInput" style="width: 460px;height: 100px;display: block;margin-top: 5px;border: none;outline: none;background-color: #f7f7f7;resize:none;overflow-y: auto;scrollbar-width: thin;"></textarea>
          <div class="msg-btn" :style="{color:msgModel.trim()!==''?'white':'#b9b9b9',cursor:msgModel.trim()!==''?'pointer':'not-allowed'}" @click="sendMsg">发送</div>
        </div>
      </div>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUnReadMsgCount, getMsg, changeMsgToRead, getMoreMsg, addMsg } from '@/api/contactmsgs/index.js'
import contactUs from '@/assets/styles/contactus.svg'
import contactUsHover from '@/assets/styles/contactushover.svg'
import leaveMsg from '@/assets/styles/leavemsg.svg'
import leaveMsgHover from '@/assets/styles/leavemsghover.svg'
import userMsg from '@/assets/styles/usermsg.svg'
import userMsgHover from '@/assets/styles/usermsghover.svg'
import msgBox from '@/assets/styles/msgbox.svg'
import msgBoxHover from '@/assets/styles/msgboxhover.svg'
import defaultAvatar from '@/assets/styles/defaultUser.svg'
import { getUserInfo } from '@/api/user/index'
import serviceQR from '@/assets/serviceQR.png'
export default {
  name: 'ContactBox',
  props: ['receiverId'],
  data () {
    return {
      serviceQR,
      contactUsDialog: false,
      msgModel: '',
      defaultAvatar,
      isContactUsHover: false,
      isLeaveMsgHover: false,
      isMsgBoxHover: false,
      isUserMsgHover: false,
      hasMoreMsg: false,
      contactUs,
      contactUsHover,
      leaveMsg,
      leaveMsgHover,
      userMsg,
      userMsgHover,
      msgBox,
      msgBoxHover,
      receiverInfo: null,
      dialogVisible: false,
      unReadMsgCount: 0,
      contactMsgQuery: {
        pageNo: 1,
        pageSize: 10,
        senderId: null,
        queryTime: null
      },
      senderInfoList: [],
      selectedUserId: null,
      selectedMsgList: [],
      selectedUserName: '',
      selectedUserAvatar: null,
      isContact: false
    }
  },
  methods: {
    openContactUsDialog () {
      this.contactUsDialog = true
    },
    async sendMsg () {
      if (this.msgModel.trim() === '') {
        this.$message.warning('留言为空')
        return
      }
      const resAddMsg = await addMsg({ receiverId: this.selectedUserId, content: this.msgModel })
      if (resAddMsg.code === 1) {
        this.selectedMsgList.push(resAddMsg.data)
        this.$nextTick(() => {
          const msgBody = this.$refs.msgBody
          msgBody.scrollTo(0, msgBody.scrollHeight - msgBody.clientHeight)
          this.$refs.msgInput.focus()
          this.msgModel = ''
        })
      }
    },
    async getMoreMsg () {
      this.contactMsgQuery.pageNo = this.contactMsgQuery.pageNo + 1
      const resGetMoreMsg = await getMoreMsg(this.contactMsgQuery)
      if (resGetMoreMsg.code === 1) {
        const resMoreMsgList = resGetMoreMsg.data.list
        this.selectedMsgList.unshift(...(resMoreMsgList.reverse()))
        if (resMoreMsgList.length < 10) {
          this.hasMoreMsg = false
        } else {
          this.hasMoreMsg = true
        }
      }
    },
    formatDate (date, format) {
      const map = {
        Y: date.getFullYear(),
        M: date.getMonth() + 1, // getMonth() 返回的是0-11，所以要加1
        D: date.getDate(),
        H: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds()
      }

      return format.replace(/Y|M|D|H|m|s/g, match => {
        let value = map[match]
        if (match === 'M' || match === 'D' || match === 'H' || match === 'm' || match === 's') {
          // 小于10时前面补零
          value = value < 10 ? '0' + value : value
        }
        return value
      })
    },
    changeSelectedItem (userId) {
      this.selectedUserId = userId
    },
    async showMsgDialog (isContact) { // 是留言还是查看所有消息
      this.dialogVisible = true
      this.isContact = isContact
      const resGetMsg = await getMsg()
      if (resGetMsg.code === 1) {
        if (resGetMsg.data.senderInfoList != null) {
          this.senderInfoList = resGetMsg.data.senderInfoList.sort((item1, item2) => {
            const date1 = new Date(item1.latestMsg.createTime)
            const date2 = new Date(item2.latestMsg.createTime)
            return (date1 > date2) ? -1 : 1
          })
        }
        if (isContact) {
        // 需要获取消息接收者的头像和用户名信息，并且将它放在留言信息列表的第一位
          if (!this.senderInfoList.some(item => item.userId === this.receiverId)) {
            if (!(this.receiverId === this.$store.state.user.user.id)) {
              const res = await getUserInfo(this.receiverId)
              this.receiverInfo = res.data
              this.senderInfoList.unshift({
                userId: this.receiverInfo.id,
                userName: this.receiverInfo.userName,
                avatar: this.receiverInfo.avatar,
                latestMsg: null,
                hasUnRead: false
              })
            }
          } else { // 聊天列表中存在这个对象，那么就需要将该对象提前至数组最开始的位置
            const targetIndex = this.senderInfoList.findIndex(item => item.userId === this.receiverId)
            if (targetIndex > -1) {
              const spliceRes = this.senderInfoList.splice(targetIndex, 1)[0]
              this.senderInfoList.unshift(spliceRes)
            }
          }
        }
        this.senderInfoList = this.senderInfoList.map(item => {
          return {
            ...item,
            hasUnRead: false
          }
        })
        if (resGetMsg.data.unReadMsgs != null) {
          const unreadMsgIds = Object.keys(resGetMsg.data.unReadMsgs)
          unreadMsgIds.forEach(item1 => {
            this.senderInfoList.forEach(item2 => {
              if (item2.userId === item1) {
                item2.hasUnRead = true
              }
            })
          })
        }
      }
      this.changeSelectedItem(this.senderInfoList.length > 0 ? this.senderInfoList[0].userId : null)
    },
    goToUserInfo () {
      if (this.$route.path === '/userinfo') {
        return
      }
      this.$router.push({
        path: '/userinfo',
        query: {
          userId: this.receiverId
        }
      })
    }
  },
  async created () { // 需要查看未读消息的数量，这个数量从vuex的内存中获取，不保存到本地中
    if (this.$store.getters.token != null) {
      const res = await getUnReadMsgCount(this.$store.state.user.user.id)// 这个不算是敏感数据，该接口可以开放，但是获取详细消息就该登录了
      if (res.code === 1) {
        this.unReadMsgCount = res.data
      }
    }
  },
  watch: {
    msgModel (newVal, oldVal) {
      if (newVal != null && newVal.length > 1000) {
        this.$message.warning('最多允许发送1000字消息')
        this.msgModel = oldVal
      }
    },
    async selectedUserId (newVal, oldVal) {
      if (newVal !== null) {
        this.contactMsgQuery.senderId = newVal
        this.contactMsgQuery.pageNo = 1
        this.contactMsgQuery.queryTime = this.formatDate(new Date(), 'Y-M-D H:m:s')
        const resChangeMsgToRead = await changeMsgToRead(newVal, this.contactMsgQuery.queryTime)
        if (resChangeMsgToRead.code === 1) {
          this.unReadMsgCount = resChangeMsgToRead.data
        }
        this.selectedUserName = this.senderInfoList.find(item => item.userId === newVal).userName
        this.selectedUserAvatar = this.senderInfoList.find(item => item.userId === newVal).avatar
        this.senderInfoList.forEach(item => {
          if (item.userId === newVal) {
            item.hasUnRead = false
          }
        })
        const resGetMoreMsg = await getMoreMsg(this.contactMsgQuery)
        if (resGetMoreMsg.code === 1) {
          this.selectedMsgList = resGetMoreMsg.data.list
          if (this.selectedMsgList.length < 10) {
            this.hasMoreMsg = false
          } else {
            this.hasMoreMsg = true
          }
          this.selectedMsgList.reverse()
        }
      }
      this.$nextTick(() => {
        const msgBody = this.$refs.msgBody
        msgBody.scrollTo(0, msgBody.scrollHeight - msgBody.clientHeight)
        this.$refs.msgInput.focus()
      })
    }
  }
}
</script>

<style scoped lang="less">
.contact-us-dialog{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 15px;
  padding-right: 15px;
  h1,h2{
    text-align: center;
    margin: 10px auto;
  }
}

.contact-box{
    width: 160px;
    height: 190px;
    border: 1px solid rgb(5, 140, 250);
    position: fixed;
    top: 250px;
    right: 80px;
    z-index: 900;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 3px rgb(158, 158, 158);
    box-sizing: border-box;
    .contact-box-item{
      display: flex;
      height: 46px;
      padding-left: 20px;
      padding-right: 20px;
      border-bottom: 1px solid rgb(179, 178, 178);
      cursor: pointer;
      .contact-box-item-label{
        line-height: 46px;
        margin-left: 10px;
      }
    }
    .contact-box-item:hover{
      color:#00a6ff;
    }
}
/deep/.el-dialog__header{
  width: 0;
  height: 0;
  position: absolute;
  overflow: clip;
  box-sizing: border-box;
  padding: 0;
}
/deep/.el-dialog__body{
  padding: 0px;
}

.msg-container{
  height: 500px;
  overflow-y: auto;
  scrollbar-width: thin;
  display: flex;
  .msg-container-left{
    width: 225px;
    height: 100%;
    border-right: 1px solid rgb(238, 238, 238);
    padding-top: 6%;
    padding-bottom: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    scrollbar-width: thin;
    .msg-container-left-item{
      width: 100%;
      height: 60px;
      padding-left: 8px;
      display: flex;
      cursor: default;
      position: relative;
      box-sizing: border-box;
      .el-icon-close:hover{
        color: #fea61e;
        cursor: pointer;
      }
    }
    .active{
      background-color: #06a4fa;
      color: white;
    }
  }
  .msg-container-right{
    width: 475px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f7f7f7;
    .msg-container-right-header{
      width: 100%;
      height: 7%;
      border-bottom: 1px solid rgb(231, 231, 231);
      position: relative;
      .el-icon-close{
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 20px;
        cursor: pointer;
      }
      .el-icon-close:hover{
        color: #00a6ff;
      }
    }
    .msg-container-right-top{
      width: 100%;
      height: 63%;
      border-bottom: 1px solid rgb(231, 231, 231);
      overflow-y: auto;
      scrollbar-width: thin;
    }
    .msg-container-right-bottom{
      width: 100%;
      height: 30%;
      position: relative;
      .msg-btn{
        width: 92px;
        height: 25px;
        font-size: 12px;
        background-color:#06a4fa ;
        border-radius: 5px;
        text-align: center;
        color: white;
        position: absolute;
        right: 10px;
        bottom: 10px;
        line-height: 25px;
      }
    }
  }
}
</style>
